export const STOAT_HOST = "chat.ylabstest.top";
export const STOAT_API = "https://chat.ylabstest.top/api";
export const STOAT_WS = "wss://chat.ylabstest.top/ws";
export const STOAT_MEDIA = "https://chat.ylabstest.top/autumn";
export const STOAT_PROXY = "https://chat.ylabstest.top/january";
export const STOAT_GIFBOX = "https://chat.ylabstest.top/gifbox";

/** App `stoat.json` endpoint format */
export interface AppConfig {
  api: string;
}

/**
 * Fetch env var by name, optionally only when in dev mode.
 * Also prevents compiler from optimizing out injected strings in Docker
 */
const getEnv = (name: string, devOnly?: boolean) =>
  !devOnly || import.meta.env.DEV
    ? (import.meta.env[name] as string)
    : undefined;

const DEFAULT_HOST =
  getEnv("VITE_DEV_HOST", true) || getEnv("VITE_HOST") || STOAT_HOST;

const DEFAULT_API_URL =
  getEnv("VITE_DEV_API_URL", true) || getEnv("VITE_API_URL") || STOAT_API;

if (DEFAULT_API_URL !== STOAT_API && DEFAULT_HOST === STOAT_HOST)
  throw "VITE_HOST required when VITE_API_URL is set!";

export default {
  /** Default instance (without the protocol) */
  DEFAULT_HOST,
  /** API URL of default instance */
  DEFAULT_API_URL,
  /** WebSocket URL of default instance */
  DEFAULT_WS_URL: getEnv("VITE_WS_URL") || STOAT_WS,
  /** Media (autumn) URL of default instance */
  DEFAULT_MEDIA_URL: getEnv("VITE_MEDIA_URL") || STOAT_MEDIA,
  /** Proxy (january) URL of default instance */
  DEFAULT_PROXY_URL: getEnv("VITE_PROXY_URL") || STOAT_PROXY,
  /** Gifbox URL of default instance */
  DEFAULT_GIFBOX_URL: getEnv("VITE_GIFBOX_URL") || STOAT_GIFBOX,
  /** WS server override for development */
  DEV_WS_URL: getEnv("VITE_DEV_WS_URL"),
  /** Media server override for development */
  DEV_MEDIA_URL: getEnv("VITE_DEV_MEDIA_URL"),
  /** Proxy server override for development */
  DEV_PROXY_URL: getEnv("VITE_DEV_PROXY_URL"),
  /** Gifbox server override for development */
  DEV_GIFBOX_URL: getEnv("VITE_DEV_GIFBOX_URL"),
  /**
   * RNNoise worklet CDN host location. Defaults to blank, which uses the url provided by the livekit-rnnoise-processor package.
   */
  RNNOISE_WORKLET_CDN_URL: getEnv("VITE_RNNOISE_WORKLET_CDN_URL"),
  /**
   * Session ID to set during development.
   */
  DEVELOPMENT_SESSION_ID: getEnv("VITE_SESSION_ID", true),
  /**
   * Token to set during development.
   */
  DEVELOPMENT_TOKEN: getEnv("VITE_TOKEN", true),
  /**
   * User ID to set during development.
   */
  DEVELOPMENT_USER_ID: getEnv("VITE_USER_ID", true),
};
